import NiceModal from "@ebay/nice-modal-react"
import { FileText } from "lucide-react"
import { observer } from "mobx-react"
import { useCodeStore } from "../store/context"
import { CopyMarkdownModal } from "./CopyMarkdownModal"

interface CopyMarkdownButtonProps {
    taskId: string
}

export const CopyMarkdownButton = observer(({ taskId }: CopyMarkdownButtonProps) => {
    const codeStore = useCodeStore()
    const task = codeStore.tasks.getTask(taskId)
    const hasActionEvents = task?.events.some((event) => event.type === "action") ?? false
    const hasProviderSessions = (task?.providerSessions?.length ?? 0) > 0

    if (!hasActionEvents && !hasProviderSessions) return null

    return (
        <button
            type="button"
            className="btn flex h-7 w-7 flex-shrink-0 items-center justify-center text-muted hover:bg-base-200 hover:text-base-content"
            onClick={() => void NiceModal.show(CopyMarkdownModal, { taskId })}
            title="Copy chat as Markdown"
            aria-label="Copy chat as Markdown"
        >
            <FileText size={14} />
        </button>
    )
})
